module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/WyFxNX/CoverDesign.jpg?1684515368007",
      "alt": "This image is the cover for the book Blyd and Pearce"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Blyd and Pearce\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Born into poverty and orphaned young, Daveth Blyd had one chance for success when his fighting prowess earned him a place in the Tangye city guard—a place he lost to false accusations of theft. Now he scrapes out a living searching for wayward spouses and missing children. When a nobleman offers him a small fortune to find an entertainer who’s stolen a ring, Daveth takes the case.")]), _vm._v(" "), _c('p', [_vm._v("While Jory Pearce may or may not be a thief, he certainly can’t be trusted. But, enchanted by Jory’s beauty and haunting voice, Daveth soon finds himself caught in the middle of a conspiracy. As he searches desperately for answers, he realizes that he’s also falling for Jory. The two men face river wraiths, assassins, a necromancer, and a talking head that could be Daveth’s salvation on their quest for the truth. But with everyone’s integrity in question and Death eager to dance, Daveth will need more than sorcery to survive.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kim Fielding\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0